import { useContext } from 'react';
import { useValidateDraftCondition } from '../../hooks/useValidateDraftCondition';
import { useViewerActions } from '../../hooks/useViewerActions';
import FormattedMessage from 'I18n/components/FormattedMessage';
import SegmentationFiltersInstanceContext from '../../state/SegmentationFiltersInstanceContext';
import { Button } from 'foundations-components/transitional/components/Button';
import { AddIcon } from 'foundations-assets';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ViewerFooter = () => {
  const {
    draftCondition,
    internalDraftValue,
    isInEditMode,
    props: {
      isAndGroup,
      isReadOnly,
      uiMessages: {
        addFilterGroupButtonLabel
      },
      useOnePanel
    }
  } = useContext(SegmentationFiltersInstanceContext);
  const {
    onAddFilterGroup
  } = useViewerActions();
  const {
    validateDraftCondition
  } = useValidateDraftCondition();
  const hasNoGroups = !internalDraftValue || internalDraftValue.conditions.size === 0;
  if (isReadOnly || isAndGroup || hasNoGroups || !isInEditMode || !useOnePanel) {
    return null;
  }
  const isEditorOpen = Boolean(draftCondition);
  const isCurrentlyAddingNewGroup = Boolean(draftCondition && draftCondition.isAddingNew);
  const onAddFilterGroupClicked = () => {
    if (isEditorOpen) {
      validateDraftCondition();
    }
    onAddFilterGroup();
  };
  return /*#__PURE__*/_jsx(View, {
    paddingBlock: "200",
    textAlign: "center",
    borderBlockStartWidth: "100",
    borderBlockEndWidth: "0",
    borderInlineStartWidth: "0",
    borderInlineEndWidth: "0",
    borderStyle: "solid",
    borderColor: "border-core-default",
    children: /*#__PURE__*/_jsx(Tooltip, {
      disabled: !isCurrentlyAddingNewGroup,
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "newCustomerDataFilters.filtersViewer.disabledAddGroupTooltip"
      }),
      children: /*#__PURE__*/_jsx(Button, {
        "data-selenium-info": "Or",
        "data-selenium-test": "fr-viewer-add-filter-btn",
        disabled: isCurrentlyAddingNewGroup,
        onClick: onAddFilterGroupClicked,
        size: "sm",
        use: "tertiary-light",
        responsive: false,
        children: /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          gap: "100",
          children: [/*#__PURE__*/_jsx(AddIcon, {}), addFilterGroupButtonLabel || /*#__PURE__*/_jsx(FormattedMessage, {
            message: "newCustomerDataFilters.filtersViewer.addGroup"
          })]
        })
      })
    })
  });
};
export default ViewerFooter;